export enum BooleanDropdownList {
  ALL = 'ALL',
  TRUE = 'TRUE',
  FALSE = 'FALSE',
}
